module.exports = __webpack_public_path__ + "static/media/right-arrow.2696a37a.svg";